import { useEffect, useState } from 'react';
import { Trash2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/contacts');
      setItems(r.data);
    } catch { toast.error('Erreur'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Supprimer ce message ?')) return;
    try {
      await api.delete(`/admin/contacts/${id}`);
      setItems(it => it.filter(x => x.id !== id));
      toast.success('Message supprimé');
    } catch { toast.error('Erreur'); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="h2 text-anthracite-950">Messages de contact</h1>
        <p className="text-muted-foreground mt-1">{items.length} message{items.length > 1 ? 's' : ''}</p>
      </div>

      {loading ? (
        <div className="py-12 text-center"><Loader2 className="h-6 w-6 animate-spin mx-auto text-brand-700" /></div>
      ) : items.length === 0 ? (
        <div className="card-base p-12 text-center text-muted-foreground">Aucun message.</div>
      ) : (
        <div className="space-y-3">
          {items.map(m => (
            <article key={m.id} className="card-base p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-heading font-semibold text-anthracite-950">{m.nom} <span className="text-sm text-muted-foreground font-normal">• {new Date(m.created_at).toLocaleString('fr-FR')}</span></p>
                  <p className="text-sm text-brand-700 mt-0.5">{m.sujet}</p>
                  <div className="text-xs text-muted-foreground mt-1">
                    <a href={`mailto:${m.email}`} className="hover:underline">{m.email}</a>{m.telephone && <> • <a href={`tel:${m.telephone}`} className="hover:underline">{m.telephone}</a></>}
                  </div>
                  <p className="mt-3 text-sm text-anthracite-800 line-clamp-3 whitespace-pre-wrap">{m.message}</p>
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" onClick={() => setSelected(m)}>Voir</Button>
                  <Button variant="outline" size="sm" onClick={() => remove(m.id)} className="text-destructive border-destructive/30 hover:bg-destructive/10"><Trash2 className="h-3.5 w-3.5" /></Button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-xl">
          {selected && (
            <>
              <DialogHeader><DialogTitle>{selected.sujet}</DialogTitle></DialogHeader>
              <div className="text-sm space-y-2">
                <p><span className="text-muted-foreground">De:</span> {selected.nom} ({selected.email})</p>
                {selected.telephone && <p><span className="text-muted-foreground">Téléphone:</span> {selected.telephone}</p>}
                <p><span className="text-muted-foreground">Date:</span> {new Date(selected.created_at).toLocaleString('fr-FR')}</p>
                <div className="mt-3 p-3 rounded-lg bg-anthracite-100/50 whitespace-pre-wrap">{selected.message}</div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
